import React, {useState} from 'react';

import cs from 'classnames';
import {bootstrapzIndex} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import {gt} from 'app/utils/i18n';

import {CreateFolderModal} from './CreateFolder';

import type {
  BasicTeamSerializedType,
  FolderHashidSerializedType,
  FolderSerializedType,
} from 'sweet-types';

interface Props {
  parent: FolderHashidSerializedType | FolderSerializedType | null;
  teams?: Array<BasicTeamSerializedType>;
  autoFocus?: boolean;
  className?: string;
  canEdit: boolean;
}

export function CreateFolderLink({
  parent,
  teams,
  autoFocus,
  canEdit,
  className = '',
}: Props) {
  if (!canEdit) {
    return null;
  }

  const [creating, setCreating] = useState(false);
  return (
    <>
      <button
        className={cs(className, 'btn btn-link btn-sm pl-0 d-flex py-2')}
        onClick={() => setCreating(true)}
      >
        <StyledIconDiv>
          <i className="fas fa-plus-circle" />
        </StyledIconDiv>
        {gt('Add new Folder')}
      </button>
      <CreateFolderModal
        show={creating}
        onCancel={() => setCreating(false)}
        parent={parent}
        teams={teams}
        autoFocus={autoFocus}
        zIndex={bootstrapzIndex.popover}
      />
    </>
  );
}

const StyledIconDiv = styled.div`
  width: 32px;
`;
